import { createTheme } from '@mui/material';

// UnifyCX brand palette. Primary colors only for fonts/UI; the two accents
// (#f0f5f7, #6fe270) are FILLS ONLY — never used as text color.
export const BRAND = {
  blue: '#1f5ff5',      // primary
  lightBlue: '#65cfff', // primary light
  navy: '#222e6b',      // primary dark
  ink: '#1b1b1b',       // text
  white: '#ffffff',
  mist: '#f0f5f7',      // accent (background fill)
  green: '#6fe270',     // accent (success fill)
};

// Standard brand header/hero gradient (navy -> blue). Used across app bars and
// login/dashboard headers so every surface reads as one brand.
export const BRAND_GRADIENT = `linear-gradient(135deg, ${BRAND.navy} 0%, ${BRAND.blue} 100%)`;
export const BRAND_GRADIENT_LIGHT = `linear-gradient(135deg, ${BRAND.blue} 0%, ${BRAND.lightBlue} 100%)`;

const theme = createTheme({
  palette: {
    primary: { main: BRAND.blue, light: BRAND.lightBlue, dark: BRAND.navy, contrastText: BRAND.white },
    secondary: { main: BRAND.navy, light: BRAND.blue, dark: BRAND.ink, contrastText: BRAND.white },
    success: { main: BRAND.green, dark: '#3fae54', contrastText: BRAND.ink },
    info: { main: BRAND.lightBlue, contrastText: BRAND.ink },
    background: { default: BRAND.mist, paper: BRAND.white },
    text: { primary: BRAND.ink, secondary: '#4a5578' },
  },
  typography: { fontFamily: 'Roboto, Arial, sans-serif' },
  components: {
    MuiButton: {
      styleOverrides: { root: { borderRadius: 8, textTransform: 'none', fontWeight: 600 } },
    },
    MuiCard: {
      styleOverrides: { root: { borderRadius: 12, boxShadow: '0 2px 12px rgba(34,46,107,0.08)' } },
    },
  },
});

export default theme;
